import { Avatar } from "@vega-core/components/Avatar/Avatar";
import { EMPTY_CELL_VALUE } from "@vega-core/constants/global";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type PersonCellProps = {
  name?: string;
  email?: string;
  emptyLabel?: string;
  avatarVariant?: "outlined" | "primary" | "secondary";
  className?: string;
  dataTestId?: string;
};

/**
 * Presentational person cell shared across the CoInvestmentsGP Share* and
 * Track* tables: avatar + name + email, or a fallback when there is no person.
 */
export const PersonCell = ({
  name,
  email,
  emptyLabel = EMPTY_CELL_VALUE,
  avatarVariant = "primary",
  className,
  dataTestId,
}: PersonCellProps) => {
  if (!name) {
    return (
      <span className={className} data-testid={dataTestId}>
        {emptyLabel}
      </span>
    );
  }

  return (
    <div
      className={cnTwMerge("flex gap-1 items-center min-w-0", className)}
      data-testid={dataTestId}
    >
      <Avatar initials={name} variant={avatarVariant} />
      <div className="flex flex-col items-start min-w-0">
        <span className="text-text/primary body-small-medium truncate">
          {name}
        </span>
        {email ? (
          <span className="text-text/secondary body-small-regular truncate">
            {email}
          </span>
        ) : null}
      </div>
    </div>
  );
};
